import { swrQueryFetcher } from '@/utils/swr-utils';
import { type CustomerSession } from '@soluto-private/asp-core';
import useSWR from 'swr';

export function useAuthorizedCustomerSession() {
  const { data, isLoading, mutate } = useSWR<{
    customerSession: CustomerSession;
  }>('/api/customer-session', swrQueryFetcher, { revalidateOnMount: true });
  return {
    customerSession: data ? data.customerSession : undefined,
    isLoadingCustomerSession: isLoading,
    mutateCustomerSession: mutate,
  };
}
